if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.targetButton = document.getElementById(this.dataset.targetButton);
        this.button = this.querySelector('.sticky-buy-bar__button');
        this.priceWrapper = this.querySelector('.sticky-buy-bar__price');

        if (!this.targetButton) return;

        this.button?.addEventListener('click', () => this.targetButton.click());

        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries[0]));
        this.observer.observe(this.targetButton);

        this.resizeObserver = new ResizeObserver(() => this.updateBodySpacing());
        this.resizeObserver.observe(this);

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.unsubscribeVariantChange?.();
        document.body.style.paddingBottom = '';
      }

      handleIntersection(entry) {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.classList.toggle('sticky-buy-bar--visible', scrolledPast);
        this.updateBodySpacing();
      }

      updateBodySpacing() {
        const isVisible = this.classList.contains('sticky-buy-bar--visible') && this.offsetHeight > 0;
        document.body.style.paddingBottom = isVisible ? `${this.offsetHeight}px` : '';
      }

      handleVariantChange({ data: { sectionId, html } }) {
        if (sectionId !== this.dataset.section) return;

        const updatedButton = html.getElementById(this.dataset.targetButton);
        if (this.button && updatedButton) {
          this.button.toggleAttribute('disabled', updatedButton.hasAttribute('disabled'));
          const updatedLabel = updatedButton.querySelector('span')?.textContent;
          const label = this.button.querySelector('span');
          if (label && updatedLabel) label.textContent = updatedLabel;
        }

        const updatedPrice = html.getElementById(`price-${sectionId}`);
        if (this.priceWrapper && updatedPrice) {
          this.priceWrapper.innerHTML = updatedPrice.innerHTML;
        }
      }
    }
  );
}
